import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import copy from 'copy-to-clipboard';
import CopySVG from './svgs/copy';
var CopyLink = function CopyLink(_ref) {
    var text = _ref.text, iconClassName = _ref.iconClassName, btnClassName = _ref.btnClassName, label = _ref.label;
    var slugify = function slugify(string) {
        return string.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-');
    };
    var sluggedTitle = slugify(text);
    var _useState = useState(false), show = _useState[0], setShow = _useState[1];
    var handleClick = function handleClick(event) {
        setShow(true);
        setTimeout(function () {
            return setShow(false);
        }, 1000);
        copy(text);
        event.preventDefault();
    };
    return /*#__PURE__*/ React.createElement(OverlayTrigger, {
        trigger: ['hover', 'click'],
        placement: "bottom-end",
        delay: {
            show: 0,
            hide: 0
        },
        overlay: /*#__PURE__*/ React.createElement(Tooltip, {
            id: "tooltip-" + sluggedTitle + "-onboard"
        }, label)
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "btn btn-sm " + btnClassName + " p-0 m-0 border-0 align-text-top mx-auto",
        onClick: handleClick
    }, /*#__PURE__*/ React.createElement(OverlayTrigger, {
        trigger: ['hover', 'focus'],
        placement: "bottom-end",
        delay: {
            show: 0,
            hide: 450
        },
        show: show,
        overlay: /*#__PURE__*/ React.createElement(Tooltip, {
            id: "tooltip-" + sluggedTitle + "-onboard"
        }, "Copied!")
    }, /*#__PURE__*/ React.createElement(CopySVG, {
        height: "14",
        className: iconClassName
    }))));
};
export default CopyLink;
